<template lang="pug">
  v-container.login(fluid, fill-height)
    v-layout(row, wrap, align-center)
      v-flex(sm6, offset-sm3, lg4, offset-lg4, v-if='!C.state.emailSent && !C.state.magicLinkAttempt')
        v-alert.mb-4(v-if='C.error.active' color='error', icon='warning', value='true')
          | {{ C.error.message }}
        v-container(grid-list-md, text-xs-center)
          v-layout(row, wrap)
            v-flex.mb-3(xs12)
              svg(width='123', height='29', viewbox='0 0 123 29', xmlns='http://www.w3.org/2000/svg')
                g(fill='none', fill-rule='evenodd')
                  path(d='M32 1.284h5.633c.836 0 1.621.083 2.355.249.734.165 1.373.441 1.917.828.545.387.975.9 1.29 1.538.316.64.474 1.424.474 2.355 0 .9-.162 1.68-.486 2.344a4.543 4.543 0 0 1-1.313 1.633 5.592 5.592 0 0 1-1.917.947 8.493 8.493 0 0 1-2.32.307H35.48v5.231H32V1.284zm5.42 7.432c1.894 0 2.84-.82 2.84-2.462 0-.804-.24-1.372-.722-1.704-.48-.331-1.187-.497-2.118-.497h-1.94v4.663h1.94zm11.745-.331h1.799c.915 0 1.613-.194 2.095-.58.48-.387.721-.959.721-1.716 0-.758-.24-1.286-.721-1.586-.482-.3-1.18-.45-2.095-.45h-1.799v4.332zm4.876 8.331l-2.959-5.562h-1.917v5.562h-3.48V1.284h5.563c.82 0 1.59.079 2.308.237.718.158 1.345.422 1.881.793.537.37.963.864 1.278 1.479.316.615.474 1.38.474 2.296 0 1.136-.249 2.07-.746 2.804a4.548 4.548 0 0 1-2 1.645l3.503 6.178h-3.905zM65.88 17c-1.042 0-1.993-.185-2.853-.556a6.201 6.201 0 0 1-2.213-1.598c-.615-.694-1.092-1.538-1.432-2.532-.339-.994-.509-2.123-.509-3.385 0-1.262.17-2.387.51-3.373.339-.986.816-1.814 1.431-2.485a6.147 6.147 0 0 1 2.213-1.538c.86-.355 1.81-.533 2.852-.533 1.042 0 1.992.178 2.852.533.86.355 1.598.871 2.213 1.55.616.678 1.093 1.51 1.432 2.497.34.986.51 2.102.51 3.349 0 1.262-.17 2.39-.51 3.385-.339.994-.816 1.838-1.432 2.532a6.201 6.201 0 0 1-2.213 1.598c-.86.37-1.81.556-2.852.556zm0-3.006c1.057 0 1.893-.454 2.508-1.36.616-.908.923-2.143.923-3.705 0-1.546-.307-2.753-.923-3.621-.615-.868-1.451-1.302-2.509-1.302-1.057 0-1.893.434-2.509 1.302-.615.868-.923 2.075-.923 3.621 0 1.562.308 2.797.923 3.704.616.907 1.452 1.361 2.51 1.361zm9.259-12.71h3.48v12.497h6.106v2.935H75.14V1.284zm11.603 0h3.48v15.432h-3.48V1.284zm6.467 0h9.728v2.935h-6.249v3.574h5.35v2.935h-5.35v5.988h-3.48V1.284zm11.745 0h3.479v15.432h-3.48V1.284zm5.733 7.81c0-1.277.197-2.417.591-3.42.395-1.001.927-1.85 1.598-2.544a6.775 6.775 0 0 1 2.343-1.586A7.43 7.43 0 0 1 118.05 1c.962 0 1.834.201 2.615.604.781.402 1.432.871 1.953 1.408L120.7 5.166a5.412 5.412 0 0 0-1.196-.852c-.402-.206-.872-.308-1.408-.308-.537 0-1.037.114-1.503.343a3.627 3.627 0 0 0-1.219.982c-.347.426-.62.947-.816 1.562-.198.616-.296 1.31-.296 2.083 0 1.594.339 2.829 1.017 3.704.679.876 1.586 1.314 2.722 1.314.631 0 1.184-.126 1.657-.379.473-.252.9-.583 1.278-.994l1.917 2.107c-.647.757-1.384 1.325-2.213 1.704a6.384 6.384 0 0 1-2.686.568 7.79 7.79 0 0 1-2.817-.509 6.576 6.576 0 0 1-2.32-1.503c-.662-.663-1.183-1.487-1.561-2.473-.379-.986-.568-2.126-.568-3.42z', fill='#FFFFFF')
                  path(d='M13.519 17.098L0 28.903v-27a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1v14.195a1 1 0 0 1-1 1h-9.481zM5.833 5.53a.5.5 0 0 0-.5.5v6.44h12.834a.5.5 0 0 0 .5-.5V6.03a.5.5 0 0 0-.5-.5H5.833zm-.5 6.94v4.628l5.334-4.627H5.333z', fill='#FFFFFF', opacity='0.5')

        v-card.card--borderless.pa-5
          v-card-title(primary-title='')
            h3.headline.mb-0 Sign In
          v-card-text.py-0
            v-form(@submit.prevent='C.form.trigger.submit')
              v-text-field.input--box(v-model='C.form.selected.account.email', label='E-mail', single-line, :rules="[rules.required, rules.email]", required='')
              v-card-text.pa-0
                v-btn(type='submit', block, large, color='primary', :loading="C.state.isLoggingIn", @click.native="loader = 'loading'")
                    | Login
                    span(slot="loader")
                        | Logging in ...
        p.pa-3.text-xs-center.white--text(v-if='CR.show.unreleased')
          | Not a member? 
          router-link.text-link.white--text(:to='{name: "MagicSignUp"}')
            | Create an account
          | .

      v-flex(sm6, offset-sm3, lg4, offset-lg4, v-if='!C.state.emailSent && C.state.magicLinkAttempt')
        v-layout.text-xs-center(column, wrap, align-center)
          v-flex.mb-3(xs12)
            svg(width='123', height='29', viewbox='0 0 123 29', xmlns='http://www.w3.org/2000/svg')
              g(fill='none', fill-rule='evenodd')
                path(d='M32 1.284h5.633c.836 0 1.621.083 2.355.249.734.165 1.373.441 1.917.828.545.387.975.9 1.29 1.538.316.64.474 1.424.474 2.355 0 .9-.162 1.68-.486 2.344a4.543 4.543 0 0 1-1.313 1.633 5.592 5.592 0 0 1-1.917.947 8.493 8.493 0 0 1-2.32.307H35.48v5.231H32V1.284zm5.42 7.432c1.894 0 2.84-.82 2.84-2.462 0-.804-.24-1.372-.722-1.704-.48-.331-1.187-.497-2.118-.497h-1.94v4.663h1.94zm11.745-.331h1.799c.915 0 1.613-.194 2.095-.58.48-.387.721-.959.721-1.716 0-.758-.24-1.286-.721-1.586-.482-.3-1.18-.45-2.095-.45h-1.799v4.332zm4.876 8.331l-2.959-5.562h-1.917v5.562h-3.48V1.284h5.563c.82 0 1.59.079 2.308.237.718.158 1.345.422 1.881.793.537.37.963.864 1.278 1.479.316.615.474 1.38.474 2.296 0 1.136-.249 2.07-.746 2.804a4.548 4.548 0 0 1-2 1.645l3.503 6.178h-3.905zM65.88 17c-1.042 0-1.993-.185-2.853-.556a6.201 6.201 0 0 1-2.213-1.598c-.615-.694-1.092-1.538-1.432-2.532-.339-.994-.509-2.123-.509-3.385 0-1.262.17-2.387.51-3.373.339-.986.816-1.814 1.431-2.485a6.147 6.147 0 0 1 2.213-1.538c.86-.355 1.81-.533 2.852-.533 1.042 0 1.992.178 2.852.533.86.355 1.598.871 2.213 1.55.616.678 1.093 1.51 1.432 2.497.34.986.51 2.102.51 3.349 0 1.262-.17 2.39-.51 3.385-.339.994-.816 1.838-1.432 2.532a6.201 6.201 0 0 1-2.213 1.598c-.86.37-1.81.556-2.852.556zm0-3.006c1.057 0 1.893-.454 2.508-1.36.616-.908.923-2.143.923-3.705 0-1.546-.307-2.753-.923-3.621-.615-.868-1.451-1.302-2.509-1.302-1.057 0-1.893.434-2.509 1.302-.615.868-.923 2.075-.923 3.621 0 1.562.308 2.797.923 3.704.616.907 1.452 1.361 2.51 1.361zm9.259-12.71h3.48v12.497h6.106v2.935H75.14V1.284zm11.603 0h3.48v15.432h-3.48V1.284zm6.467 0h9.728v2.935h-6.249v3.574h5.35v2.935h-5.35v5.988h-3.48V1.284zm11.745 0h3.479v15.432h-3.48V1.284zm5.733 7.81c0-1.277.197-2.417.591-3.42.395-1.001.927-1.85 1.598-2.544a6.775 6.775 0 0 1 2.343-1.586A7.43 7.43 0 0 1 118.05 1c.962 0 1.834.201 2.615.604.781.402 1.432.871 1.953 1.408L120.7 5.166a5.412 5.412 0 0 0-1.196-.852c-.402-.206-.872-.308-1.408-.308-.537 0-1.037.114-1.503.343a3.627 3.627 0 0 0-1.219.982c-.347.426-.62.947-.816 1.562-.198.616-.296 1.31-.296 2.083 0 1.594.339 2.829 1.017 3.704.679.876 1.586 1.314 2.722 1.314.631 0 1.184-.126 1.657-.379.473-.252.9-.583 1.278-.994l1.917 2.107c-.647.757-1.384 1.325-2.213 1.704a6.384 6.384 0 0 1-2.686.568 7.79 7.79 0 0 1-2.817-.509 6.576 6.576 0 0 1-2.32-1.503c-.662-.663-1.183-1.487-1.561-2.473-.379-.986-.568-2.126-.568-3.42z', fill='#FFFFFF')
                path(d='M13.519 17.098L0 28.903v-27a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1v14.195a1 1 0 0 1-1 1h-9.481zM5.833 5.53a.5.5 0 0 0-.5.5v6.44h12.834a.5.5 0 0 0 .5-.5V6.03a.5.5 0 0 0-.5-.5H5.833zm-.5 6.94v4.628l5.334-4.627H5.333z', fill='#FFFFFF', opacity='0.5')
        v-card.card--borderless.pa-5.pt-1
          v-card-title.justify-center(primary-title='')
            h3.headline.mb-0
              | Logging in...

      v-flex(sm6, offset-sm3, lg4, offset-lg4, v-if='C.state.emailSent')
        v-layout.text-xs-center(column, wrap, align-center)
          v-flex.mb-3(xs12)
            svg(width='123', height='29', viewbox='0 0 123 29', xmlns='http://www.w3.org/2000/svg')
              g(fill='none', fill-rule='evenodd')
                path(d='M32 1.284h5.633c.836 0 1.621.083 2.355.249.734.165 1.373.441 1.917.828.545.387.975.9 1.29 1.538.316.64.474 1.424.474 2.355 0 .9-.162 1.68-.486 2.344a4.543 4.543 0 0 1-1.313 1.633 5.592 5.592 0 0 1-1.917.947 8.493 8.493 0 0 1-2.32.307H35.48v5.231H32V1.284zm5.42 7.432c1.894 0 2.84-.82 2.84-2.462 0-.804-.24-1.372-.722-1.704-.48-.331-1.187-.497-2.118-.497h-1.94v4.663h1.94zm11.745-.331h1.799c.915 0 1.613-.194 2.095-.58.48-.387.721-.959.721-1.716 0-.758-.24-1.286-.721-1.586-.482-.3-1.18-.45-2.095-.45h-1.799v4.332zm4.876 8.331l-2.959-5.562h-1.917v5.562h-3.48V1.284h5.563c.82 0 1.59.079 2.308.237.718.158 1.345.422 1.881.793.537.37.963.864 1.278 1.479.316.615.474 1.38.474 2.296 0 1.136-.249 2.07-.746 2.804a4.548 4.548 0 0 1-2 1.645l3.503 6.178h-3.905zM65.88 17c-1.042 0-1.993-.185-2.853-.556a6.201 6.201 0 0 1-2.213-1.598c-.615-.694-1.092-1.538-1.432-2.532-.339-.994-.509-2.123-.509-3.385 0-1.262.17-2.387.51-3.373.339-.986.816-1.814 1.431-2.485a6.147 6.147 0 0 1 2.213-1.538c.86-.355 1.81-.533 2.852-.533 1.042 0 1.992.178 2.852.533.86.355 1.598.871 2.213 1.55.616.678 1.093 1.51 1.432 2.497.34.986.51 2.102.51 3.349 0 1.262-.17 2.39-.51 3.385-.339.994-.816 1.838-1.432 2.532a6.201 6.201 0 0 1-2.213 1.598c-.86.37-1.81.556-2.852.556zm0-3.006c1.057 0 1.893-.454 2.508-1.36.616-.908.923-2.143.923-3.705 0-1.546-.307-2.753-.923-3.621-.615-.868-1.451-1.302-2.509-1.302-1.057 0-1.893.434-2.509 1.302-.615.868-.923 2.075-.923 3.621 0 1.562.308 2.797.923 3.704.616.907 1.452 1.361 2.51 1.361zm9.259-12.71h3.48v12.497h6.106v2.935H75.14V1.284zm11.603 0h3.48v15.432h-3.48V1.284zm6.467 0h9.728v2.935h-6.249v3.574h5.35v2.935h-5.35v5.988h-3.48V1.284zm11.745 0h3.479v15.432h-3.48V1.284zm5.733 7.81c0-1.277.197-2.417.591-3.42.395-1.001.927-1.85 1.598-2.544a6.775 6.775 0 0 1 2.343-1.586A7.43 7.43 0 0 1 118.05 1c.962 0 1.834.201 2.615.604.781.402 1.432.871 1.953 1.408L120.7 5.166a5.412 5.412 0 0 0-1.196-.852c-.402-.206-.872-.308-1.408-.308-.537 0-1.037.114-1.503.343a3.627 3.627 0 0 0-1.219.982c-.347.426-.62.947-.816 1.562-.198.616-.296 1.31-.296 2.083 0 1.594.339 2.829 1.017 3.704.679.876 1.586 1.314 2.722 1.314.631 0 1.184-.126 1.657-.379.473-.252.9-.583 1.278-.994l1.917 2.107c-.647.757-1.384 1.325-2.213 1.704a6.384 6.384 0 0 1-2.686.568 7.79 7.79 0 0 1-2.817-.509 6.576 6.576 0 0 1-2.32-1.503c-.662-.663-1.183-1.487-1.561-2.473-.379-.986-.568-2.126-.568-3.42z', fill='#FFFFFF')
                path(d='M13.519 17.098L0 28.903v-27a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1v14.195a1 1 0 0 1-1 1h-9.481zM5.833 5.53a.5.5 0 0 0-.5.5v6.44h12.834a.5.5 0 0 0 .5-.5V6.03a.5.5 0 0 0-.5-.5H5.833zm-.5 6.94v4.628l5.334-4.627H5.333z', fill='#FFFFFF', opacity='0.5')

          v-card.pa-5.pt-1
            v-card-title.d-inline-flex(primary-title='')
              .icon-magic-link.mb-4.d-block
                svg(viewbox='0 0 160 140', aria-hidden='true', focusable='false', style='width: 160px;height: 140px;vertical-align: middle; display: inline-block; fill: currentcolor;')
                  g(id='Admin-&-Settings', stroke='none', stroke-width='1', fill='none', fill-rule='evenodd')
                    polygon(fill='#b3c0c3', points='5.568 0 60.9546667 51.9238095 116.333714 0')
                    path(d='M53.3333333,91.4285714 C53.3333333,106.666667 38.0952381,106.666667 38.0952381,106.666667 C38.0952381,106.666667 53.3333333,106.666667 53.3333333,121.904762 C53.3333333,121.904762 53.3333333,106.666667 68.5714286,106.666667 C53.3333333,106.666667 53.3333333,91.4285714 53.3333333,91.4285714', fill='#00BF1B')
                    path(d='M84.2380952,109 C84.2380952,124.238095 69,124.238095 69,124.238095 C69,124.238095 84.2380952,124.238095 84.2380952,139.47619 C84.2380952,139.47619 84.2380952,124.238095 99.4761905,124.238095 C84.2380952,124.238095 84.2380952,109 84.2380952,109', fill='#00BF1B')
                    path(d='M144.761905,45.7142857 C144.761905,45.7142857 144.761905,30.4761905 160,30.4761905 C144.761905,30.4761905 144.761905,15.2380952 144.761905,15.2380952 C144.761905,30.4761905 129.52381,30.4761905 129.52381,30.4761905 C129.52381,30.4761905 144.761905,30.4761905 144.761905,45.7142857', fill='#00BF1B')
                    path(d='M121.904762,41.9047619 L121.904762,5.22285714 L60.952381,62.3657143 L0,5.22285714 L0,83.8095238 L80,83.8095238 C80,60.6666667 98.7619048,41.9047619 121.904762,41.9047619', fill='#b3c0c3')
                    path(d='M127.619048,91.4285714 C125.325714,91.4285714 123.20381,90.7961905 121.321905,89.7790476 L115.862857,95.2380952 L120.788571,100.16381 L115.401905,105.550476 L110.47619,100.624762 L105.550476,105.550476 L100.16381,100.16381 L115.935238,84.392381 C114.918095,82.5104762 114.285714,80.3885714 114.285714,78.0952381 C114.285714,70.7314286 120.255238,64.7619048 127.619048,64.7619048 C134.982857,64.7619048 140.952381,70.7314286 140.952381,78.0952381 C140.952381,85.4590476 134.982857,91.4285714 127.619048,91.4285714 M121.904762,49.5238095 C102.967619,49.5238095 87.6190476,64.872381 87.6190476,83.8095238 C87.6190476,102.746667 102.967619,118.095238 121.904762,118.095238 C140.841905,118.095238 156.190476,102.746667 156.190476,83.8095238 C156.190476,64.872381 140.841905,49.5238095 121.904762,49.5238095', fill='#222222')
                    path(d='M127.619048,72.3809524 C124.468571,72.3809524 121.904762,74.9447619 121.904762,78.0952381 C121.904762,81.2457143 124.468571,83.8095238 127.619048,83.8095238 C130.769524,83.8095238 133.333333,81.2457143 133.333333,78.0952381 C133.333333,74.9447619 130.769524,72.3809524 127.619048,72.3809524', fill='#222222')
            v-card-text.text-xs-center
              h2.title.mb-3
                | Account access link sent to your inbox. 
              p.mb-0
                | We sent a link to 
                strong {{ C.form.selected.account.email }}
              p.mb-0
                | Click the link to be signed in





</template>

<script>
import tools from '../../assets/tools.js'
import globalSettings from '../../assets/global-settings.js'
import axios from '../../../node_modules/axios/dist/axios.js'

export default {
  data () {
    return {
      loader: null,
      loading: false,
      email: '',
      rules: {
        required: (value) => !!value || 'Required.',
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
      CR: {
        show: globalSettings.show
      },
      C: {
        state: {
          isLoggingIn: false,
          emailSent: false,
          magicLinkAttempt: false
        },
        form: {
          selected: {
            account: {
              email: ''
            }
          },
          trigger: {
            submit: () => {
              var component = this

              var submitItem = {
                email: this.C.form.selected.account.email
              }

              component.C.state.isLoggingIn = true

              axios.post(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/users/resend_magic_link`, submitItem)
              .then(function (response) {
                console.info('Magic Link Resend Magic Link Results: ', response.data)

                if (response.data.code === 200) {
                  component.C.state.emailSent = true
                } else {
                  component.C.error.active = true
                  component.C.error.message = 'E-mail failed to be sent.  Please try again.'
                }

                component.C.state.isLoggingIn = false
              })
              .catch(function (errorResponse) {
                console.error('errorResponse', errorResponse)

                component.C.state.isLoggingIn = false
              })
            },
            signin: (magicLink) => {
              var component = this

              var submitItem = {
                magic_link: magicLink
              }

              axios.post(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/users/login`, submitItem)
              .then(function (response) {
                var userData = (response.data && response.data.data && response.data.data.user)

                console.info('Magic Link Sign In Results: ', {
                  response: response,
                  userData: userData
                })

                if (userData) {
                  axios.defaults.headers.common['Authorization'] = userData.access_token
                  window.localStorage.prolific_authorization = userData.access_token
                  globalSettings.authorization.loggedIn = true
                  tools.loggedInData({
                    success: (loggedInItem) => {
                      window.localStorage.prolific_authorization_isGod = (loggedInItem.state.isGod && 'yes') || 'no'

                      if (loggedInItem.state.isGod) {
                        component.$router.push({
                          name: 'People'
                        })
                      } else {
                        component.$router.push({
                          name: 'Inventions'
                        })
                      }
                    }
                  })
                } else {
                  component.C.state.magicLinkAttempt = false

                  component.C.error.active = true
                  component.C.error.message = 'Sign in has failed.  Please try again.'
                }
              })
              .catch(function (errorResponse) {
                console.error('errorResponse', errorResponse)

                component.C.state.magicLinkAttempt = false

                component.C.error.active = true
                component.C.error.message = 'Sign in has failed.  Please try again.'
              })
            }
          }
        },
        error: {
          active: false,
          message: ''
        }
      }
    }
  },
  created () {
    if (this.$route.query.magic_link) {
      this.C.state.magicLinkAttempt = true

      this.C.form.trigger.signin(this.$route.query.magic_link)
    }
  },
  watch: {
    loader () {
      const l = this.loader
      this[l] = !this[l]

      setTimeout(() => (this[l] = false), 3000)

      this.loader = null
    }
  }
}
</script>


<style scoped>
  .alert {
    width: 100%;
  }
  .icon-magic-link {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Authentication/MagicSignIn.vue